import { useMutation } from '@tanstack/react-query'
import { setAppSpinning } from 'app/appSlice'
import { useAppDispatch } from 'hooks/useRedux'
import { useEffect, useState } from 'react'

export default function useExportById(mutateApi, fileName, fileType) {
  const dispatch = useAppDispatch()

  const [file, setFile] = useState(null)
  const mutation = useMutation({
    mutationKey: 'exportById',
    mutationFn: mutateApi,
    onMutate: () => dispatch(setAppSpinning(true)),
    onSettled: () => dispatch(setAppSpinning(false)),
    onSuccess: (res) => {
      const fileURL = res.metadata?.fileURL || res?.fileURL
      const url = fileURL
        ? /^https?:\/\//.test(fileURL)
          ? fileURL
          : `${process.env.REACT_APP_BASE_URL}${fileURL}`
        : ''
      window.open(url, '_blank')
    },
  })

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file)
      open(url, '_blank')
    }
    return () => {
      URL.revokeObjectURL(file)
      setFile(null)
    }
  }, [file])
  return {
    file,
    exportFunc: mutation.mutate,
    exportFuncAsync: mutation.mutateAsync,
  }
}
